export { LegoV2 } from './LegoV2';
import {
  useExternalDependenceValues,
  useLegoElementError,
  useCallbackElementDepend,
  useLegoElementValue,
  useLegoV2Context,
} from './hooks';
export { LegoControllerRxjs } from './controller';
export { LegoV2Context } from './context';
export { LEGO_V2_ELEMENTS } from './_Elements';
export const LegoV2Hooks = {
  /**
   *  Хук для подписки на изменения внешних зависимостей
   *  `id` - это уникальный id lego элемента
   *  `externalDependenceList` - список ключей у объекта с внешними зависимостями на которые вы подписываетесь
   */
  useExternalDependenceValues,

  /**
   *  Хук для синхронизации значения с контроллером
   *  Основной хук для работы lego элементов
   *  id - уникальный идентификатор для lego элемента
   */
  useLegoElementError,

  /**
   *  Хук для синхронизации значения с контроллером
   *  Основной хук для работы lego элементов
   *  id - уникальный идентификатор для lego элемента
   */
  useLegoElementValue,

  /** Общий контекст лего */
  useLegoV2Context,

  /**
   * - `id` - ID лего текущего лего элемента.
   * - `cb` - колбек который будет вызываться при изменении зависимости.
   * - `dep` - значение зависимости.
   *
   * Интересный хук для селектов или других элементов имеющих зависимости от других элементов.
   * Данный хук вызывает колбек если изменилась зависимость и не делает это при инициализации, чтобы не потерять начальное значение.
   * Также он обнуляет значение текущего элемента, если зависимость изменилась.
   *
   *
   * Саымый яркий пример использования, если у вас есть селект которому нужно подгружать опции в зависимости
   * от значения какого-либо поля.
   *
   * **Важно мемоизировать ссылку на колбек**
   */
  useCallbackElementDepend,
};

export type { TLegoV2Element, TLegoElementProps as TLegoV2ElementProps } from './models';
